import { logger } from "@/infrastructure/logger";
import { chatService } from "@/domain/services/chatService";
import { ChatMessage, FileIds } from "@/domain/models/chat";

// 創建模組專用的 logger 實例
const log = logger.createLogger("chatService");

/**
 * 聊天服務
 * 負責處理聊天相關的功能，如發送訊息、上傳檔案等
 */
export const useChatService = {

  /**
   * 獲取特定頁面的聊天訊息
   * @param pageId 頁面 ID
   * @returns 返回聊天訊息數組的 Promise
   */
  async getPageMessages(sessionId: string): Promise<ChatMessage[]> {
    try {
      log.info(`獲取頁面 ${sessionId} 的聊天訊息`);
      return await chatService.getPageChatMessages(sessionId);
    } catch (error) {
      log.error("獲取聊天訊息失敗", error);
      return [];
    }
  },

  /**
   * 發送訊息
   * @param message 訊息內容
   * @returns 返回一個 Promise
   */
  async sendMessage(
    sessionId: string,
    message: string,
  ): Promise<ChatMessage> {
    try {
      log.info(`發送訊息: ${message}`);
      return await chatService.sendPageChatMessage(sessionId, message);
    } catch (error) {
      log.error("發送訊息失敗", error);
      return Promise.reject(error);
    }
  },

  /**
   * 上傳檔案
   * @param file 檔案對象
   * @returns 返回一個 Promise
   */
  async uploadFile(sessionId: string, files: File[]): Promise<FileIds> {
    try {
      log.info(`上傳檔案: ${files[0].name}`, {
        fileSize: files[0].size,
      });
      return await chatService.uploadFile(sessionId, files);
    } catch (error) {
      log.error("上傳檔案失敗", error);
      return Promise.reject(error);
    }
  },
};
